import request from '@public/http/request'
import Vue from 'vue'
import { RESPONSE_CODE } from '@public/http/config'

const msgVue = new Vue()

const then = res => {
  // 二进制响应直接返回
  if (res instanceof Blob || res instanceof ArrayBuffer || Object.prototype.toString.call(res) === '[object ArrayBuffer]') {
    return res
  }
  const { code } = res
  if (code === RESPONSE_CODE.SUCCESS || code === 0) {
    return res
  } else {
    msgVue.$message.warning(res.msg)
    return Promise.reject(res)
  }
}

const fetch = function (url, data, option) {
  if (option && option.handle) { return request.apply(null, arguments) }
  return request.apply(null, arguments).then(then)
}
fetch.get = function (url, data, option) {
  if (option && option.handle) { return request.get.apply(null, arguments) }
  return request.get.apply(null, arguments).then(then)
}
fetch.post = function (url, data, option) {
  if (option && option.handle) { return request.post.apply(null, arguments) }
  return request.post.apply(null, arguments).then(then)
}
fetch.download = async function (url, data, option) {
  option = Object.assign(option || {}, { headers: { 'systemtype': 'jms' }, responseType: 'arraybuffer', timeout: 60 * 1000, handle: true })
  const arg = [url, data, option]
  if (option && option.handle) { return request.post.apply(null, arg) }
  return request.post.apply(null, arg).then(then)
}

export default fetch
